import { CommandAddress } from "./commandAddress.model";
import { CommandAttempt } from "./commandAttempt.model";
import { CommandState } from "./commandState.enum";
import { CommandStep } from "./commandStep.model";

export class CommandInfo {
  Id: string;
  Title: string;
  Payload: string;
  State: CommandState;
  ExecutedOn: Date;
  LastAttempt: CommandAttempt;
  City: string;
  Fiberhood: string;
  Block: string;
  Collapsed: boolean;
  CommandAddress: CommandAddress;
  CommandSteps: CommandStep[];
  Attempts: number;

  get Zoning() {
    let zoning = "";
    if (this.City) zoning += this.City;
    if (this.Fiberhood) zoning += " - " + this.Fiberhood;
    if (this.Block) zoning += " - " + this.Block;
    return zoning;
  }

  constructor(comm: {
    id?: string;
    title?: string;
    state?: CommandState;
    payload?: string;
    lastAttempt?: CommandAttempt;
    city?: string;
    fiberhood?: string;
    block?: string;
    collapsed: boolean;
    commandAddress?: CommandAddress;
    attempts?: number;
    executedOn?: Date;
  }) {
    this.Id = comm.id;
    this.Title = comm.title;
    this.Payload = comm.payload;
    this.State = comm.state;
    this.LastAttempt = comm.lastAttempt;
    this.City = comm.city;
    this.Fiberhood = comm.fiberhood;
    this.Block = comm.block;
    this.Collapsed = comm.collapsed;
    this.CommandAddress = comm.commandAddress;
    this.Attempts = comm.attempts;
    this.ExecutedOn = comm.executedOn;
  }
}
